import React, { FunctionComponent } from 'react';
import { IBindingAction } from '../../../../common/models/callback';
import { FormattedMessage } from 'react-intl';
import styles from './styles.module.scss';
import { concat } from '../../../../common/helpers/arrayHelper';
import Checkbox from '../../../../components/Checkbox';

interface IButtonProps {
  textIntl: string;
  defaultText: string;
  isSelected?: boolean;
  isClicked?: boolean;
  onAnimationEnd?: IBindingAction;
  onClick: IBindingAction;
}

const Button: FunctionComponent<IButtonProps> = ({
  textIntl,
  defaultText,
  isSelected = false,
  isClicked = false,
  onAnimationEnd,
  onClick
}) => (
  <button
    type="button"
    onAnimationEnd={onAnimationEnd}
    className={concat(
      styles.button,
      isSelected ? styles.selectedButton : '',
      isClicked && isSelected ? styles.animate : ''
    )}
    onClick={onClick}
  >
    <div className={styles.checkbox}>
      <Checkbox radio checked={isSelected} />
    </div>
    <span>
      <FormattedMessage id={textIntl} defaultMessage={defaultText} />
    </span>
  </button>
);

export default Button;
